import { defineMessages } from 'react-intl';

export default defineMessages({
    AddressLine1: {
        id: 'tfpa.policyChange.contacts.policyroles.Address Line 1',
        defaultMessage: 'Address Line 1',
    },
    AddressLine2: {
        id: 'tfpa.policyChange.contacts.policyroles.Address Line 2',
        defaultMessage: 'Address Line 2',
    },
    AddressLine3: {
        id: 'tfpa.policyChange.contacts.policyroles.Address Line 3',
        defaultMessage: 'Address Line 3',
    },
    City: {
        id: 'tfpa.policyChange.contacts.policyroles.City',
        defaultMessage: 'City',
    },
    PostalCode: {
        id: 'tfpa.policyChange.contacts.policyroles.ZIP Code',
        defaultMessage: 'ZIP Code',
    },
    State: {
        id: 'tfpa.policyChange.contacts.policyroles.State',
        defaultMessage: 'State',
    },
    FirstName: {
        id: 'tfpa.policyChange.contacts.policyroles.First Name',
        defaultMessage: 'First Name',
    },
    LastName: {
        id: 'tfpa.policyChange.contacts.policyroles.Last Name',
        defaultMessage: 'Last Name',
    },

    EmailValidationMessage: {
        id: 'tfpa.policyChange.contacts.policyroles.Must be a valid email address',
        defaultMessage: 'Must be a valid email address.',
    },
    Required: {
        id: 'tfpa.policyChange.contacts.policyroles.This is a required field',
        defaultMessage: 'This is a required field.',
    },
    TWIAEmailValidationError: {
        id: 'tfpa.policyChange.contacts.policyroles.You cannot register individually with TWIA',
        defaultMessage: 'You cannot register individually with TWIA. Please contact your administrator so they can add you to our system.',
    },
    TFPAEmailValidationError: {
        id: 'tfpa.policyChange.contacts.policyroles.You cannot register individually with TFPA',
        defaultMessage: 'You cannot register individually with TFPA. Please contact your administrator so they can add you to our system.',
    },
    ZIPValidationMessage: {
        id: 'tfpa.policyChange.contacts.policyroles.Must be a valid Zip Code/postal code',
        defaultMessage: 'Must be a valid postal code',
    },
    PhoneValidationMessage: {
        id: 'tfpa.policyChange.contacts.policyroles.Must be a valid 10-digit phone number',
        defaultMessage: 'Must be a valid 10-digit phone number.',
    },
    EmailAddressMatchError: {
        id: 'tfpa.policyChange.contacts.policyroles.Email addresses must match',
        defaultMessage: 'Email addresses must match',
    },
    saveFailedMsg: {
        id: 'tfpa.policyChange.contacts.policyroles.Save failed, please try again',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'tfpa.policyChange.contacts.policyroles.Can\'t Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },
    nonStandardizedMessage: {
        id: 'tfpa.policyChange.contacts.policyroles.The address you entered has not been updated to follow USPS standards. You must select Standardize Address to continue.',
        defaultMessage: 'The address you entered has not been updated to follow USPS standards. You must select Standardize Address to continue.',
    },
    standardizedMessage: {
        id: 'tfpa.policyChange.contacts.policyroles.The address you entered has been updated to follow USPS standards.',
        defaultMessage: 'The address you entered has been updated to follow USPS standards.',
    },
    standardizeAddressDetails: {
        id: 'tfpa.policyChange.contacts.policyroles.standardizeAddressDetails',
        defaultMessage: 'Standardize Address Details',
    },
    ZIPCodeValidationMessage: {
        id: 'tfpa.policyChange.contacts.policyroles.Must be a valid postal code',
        defaultMessage: 'Must be a valid Zip Code/Postal Code.',
    },
    pleaseChoose: {
        id: 'tfpa.policyChange.contacts.policyroles.Please Choose',
        defaultMessage: '-- Please Choose --',
    },

});
